/**
 * Eyebot URL Parameters Handler
 * Captures and stores eyebot session parameters from URL when enableEyebot is true
 */

(function () {
  'use strict';

  // Get enableEyebot flag from window (set by Liquid)
  const enableEyebot = window.flexOptions?.enableEyebot || false;

  const urlParams = new URLSearchParams(window.location.search);
  const sessionId = urlParams.get('sessionId');
  const userEmail = urlParams.get('userEmail');

  if (sessionId && userEmail) {
    const eyebotParams = {
      sessionId: sessionId,
      userEmail: userEmail,
      expiration: new Date().getTime() + 60000 * 120, // 2 hours from now
    };

    try {
      localStorage.setItem('eyebotUserParams', JSON.stringify(eyebotParams));
      window.eyebotUserParams = eyebotParams;

      return;
    } catch (error) {
      console.error('Failed to store eyebot parameters:', error);
    }
  }

  // Clean up expired parameters on page load
  try {
    const storedParams = localStorage.getItem('eyebotUserParams');
    if (storedParams) {
      const parsed = JSON.parse(storedParams);
      const now = new Date().getTime();

      if (parsed.expiration && parsed.expiration < now) {
        // Parameters expired
        localStorage.removeItem('eyebotUserParams');
      } else {
        // Parameters still valid, make available globally
        window.eyebotUserParams = parsed;
      }
    }
  } catch (error) {
    console.error('Failed to check stored parameters:', error);
  }
})();
